export default "__VITE_ASSET__B0a3tpRS__"